import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';

export interface UnlinkInvestigationCommand {
  readonly investigationId: string;
  readonly linkedInvestigationId: string;
}
export interface UnlinkInvestigationResult { success: boolean; }

@Injectable({ providedIn: 'root' })
export class UnlinkInvestigationUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(command: UnlinkInvestigationCommand): Observable<UnlinkInvestigationResult> {
    this._state.setUnlinkingInvestigation(true);
    this._state.setErrorLinkedInvestigations(null);
    return this._repository.unlinkInvestigation(command.investigationId, command.linkedInvestigationId).pipe(
      tap(() => {
        this._state.removeLinkedInvestigation(command.linkedInvestigationId);
        this._state.setUnlinkingInvestigation(false);
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._state.setErrorLinkedInvestigations(error.message || 'Failed to unlink investigation');
        this._state.setUnlinkingInvestigation(false);
        return throwError(() => error);
      }),
    );
  }
}
